import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { ResponsiveTypography } from '../../Typography/v3/ResponsiveTypography';
import { sizeStyles } from './sizeStyles';
import { typeStyles } from './typeStyles';

const Container = styled.div<{
  rounded?: number;
}>`
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: ${({ rounded }) => rounded || 8}px;
  cursor: pointer;
  user-select: none;

  ${sizeStyles}
  ${typeStyles}
`;

export interface QuestionNumberButtonProps {
  size?: 'small' | 'large' | 'auto';
  type?: 'default' | 'answered' | 'wrong' | 'correct' | 'missed' | 'disabled';
  textNumber?: string | number;
  selected?: boolean;
  onClick?: (e?: any) => void;
  rounded?: number;
  no?: any;
  id?: string;
}

export const QuestionNumberButton = React.memo((props: QuestionNumberButtonProps) => {
  const {
    size = 'small',
    type,
    textNumber,
    selected = false,
    onClick,
    no,
    rounded = 8,
    id,
  } = props;

  return (
    <Container
      className={cl('number-explanation', `size-${size}`, `type-${type}`, `question-no-${no}`, {
        selected,
      })}
      id={id}
      rounded={rounded}
      onClick={(e) => type !== 'disabled' && onClick?.(e)}
    >
      <ResponsiveTypography.Paragraph className="text-number">
        {textNumber}
      </ResponsiveTypography.Paragraph>
    </Container>
  );
});
